import { initConfig } from '@cian/config/browser';
import { initGlobalEventsLogs } from '@cian/events-log';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { initLogger } from '@cian/logger/browser';
import { init as initTelemetry } from '@cian/telemetry/browser';
import { init as initWeb } from '@cian/web/browser';

export function initDependencies() {
  initConfig();
  initLogger();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalEventsLogs();
  initGlobalBehaviors();
}
